import { render, staticRenderFns } from "./DiscoveryList.vue?vue&type=template&id=733830dc&"
import script from "./DiscoveryList.vue?vue&type=script&lang=js&"
export * from "./DiscoveryList.vue?vue&type=script&lang=js&"
import style0 from "./DiscoveryList.vue?vue&type=style&index=0&id=733830dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports